import NumberLink from './NumberLink'

export default NumberLink
